"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterValueInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const types_1 = require("@framework/types");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_picker_1 = require("@dzambalaorg/mui-inputs-picker");
const enum_select_1 = require("./enum-select");
const ParameterValueInput = (props) => {
    const { name = "parameterValue", prefix } = props;
    const form = (0, react_hook_form_1.useFormContext)();
    const parameterType = (0, react_hook_form_1.useWatch)({ name: `${prefix}.parameterType` });
    const parameterValue = (0, react_hook_form_1.useWatch)({ name: `${prefix}.${name}` });
    const parameterMinValue = (0, react_hook_form_1.useWatch)({ name: `${prefix}.parameterMinValue` });
    const parameterMaxValue = (0, react_hook_form_1.useWatch)({ name: `${prefix}.parameterMaxValue` });
    (0, react_1.useEffect)(() => {
        if (parameterType === types_1.ParameterType.NUMBER) {
            form.setValue(`${prefix}.${name}`, 0);
        }
        if (parameterType === types_1.ParameterType.STRING || parameterType === types_1.ParameterType.ENUM) {
            form.setValue(`${prefix}.${name}`, "");
        }
        if (parameterType === types_1.ParameterType.DATE) {
            form.setValue(`${prefix}.${name}`, new Date().toISOString());
        }
    }, [parameterType, prefix]);
    (0, react_1.useEffect)(() => {
        if (parameterType === types_1.ParameterType.NUMBER && parameterValue < parameterMinValue) {
            form.setValue(`${prefix}.${name}`, parameterMinValue);
        }
    }, [parameterMinValue, parameterType, prefix]);
    (0, react_1.useEffect)(() => {
        if (parameterType === types_1.ParameterType.NUMBER && parameterValue > parameterMaxValue) {
            form.setValue(`${prefix}.${name}`, parameterMaxValue);
        }
    }, [parameterMaxValue, parameterType, prefix]);
    return (0, react_1.useMemo)(() => {
        switch (parameterType) {
            case types_1.ParameterType.NUMBER: {
                return ((0, jsx_runtime_1.jsx)(mui_inputs_core_1.NumberInput, { name: `${prefix}.${name}`, inputProps: { min: parameterMinValue, max: parameterMaxValue } }));
            }
            case types_1.ParameterType.STRING: {
                return (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: `${prefix}.${name}` });
            }
            case types_1.ParameterType.DATE: {
                return (0, jsx_runtime_1.jsx)(mui_inputs_picker_1.DateTimeInput, { name: `${prefix}.${name}` });
            }
            case types_1.ParameterType.ENUM: {
                return (0, jsx_runtime_1.jsx)(enum_select_1.EnumSelectInput, { name: name, options: [], prefix: prefix });
            }
            default: {
                return null;
            }
        }
    }, [name, parameterType, parameterMaxValue, prefix]);
};
exports.ParameterValueInput = ParameterValueInput;
//# sourceMappingURL=index.js.map